<template>
	<div class="container d-flex flex-column justify-content-center">
        <div class="pb-12">
            <div class="card-body text-center h-100-vh d-flex align-items-center flex-column justify-content-center ">
                <img class="logo-img" :src="require(`@/assets/images/icons/docusign/token-created.svg`)" alt="success" />
                <p class="f-40 mt-4 text-success">{{ $t('Docusign Token has been created!') }}</p>
                <p class="f-18 mt-1 text-">{{ $t('The Docusign token has been created successfully, please try the request flow again.') }}</p>
                <hr>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Oauth Docusign'
};
</script>

<style lang="scss">
    .logo-img {
        height: auto;
        max-width: 20%;
        width: 15%;
    }
</style>